var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContextMenuTextLayer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.413 6.163c1.644 0 2.563.844 2.563 2.244v4.614h-1.025v-.994h-.1c-.437.72-1.175 1.113-2.075 1.113-1.307 0-2.276-.775-2.276-2.007 0-1.206.888-1.9 2.457-1.994L13.9 9.02v-.613c0-.831-.519-1.287-1.525-1.287-.807 0-1.37.306-1.52.837H9.77c.144-1.081 1.206-1.794 2.644-1.794zM5.94 4l3.326 9.021H8.083l-.906-2.582H3.588l-.906 2.582H1.5L4.826 4h1.113zm7.96 5.89l-1.813.118c-1.025.069-1.475.425-1.475 1.1 0 .688.581 1.088 1.363 1.088 1.106 0 1.925-.725 1.925-1.688v-.619zM5.432 5.456h-.1L3.92 9.483h2.926L5.432 5.457z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContextMenuTextLayer);
export default __webpack_public_path__ + "static/media/context-menu-text-layer.5d9592f8.svg";
export { ForwardRef as ReactComponent };